export default function generatePdfFilename(name: string): string {
  const slug = name
    .replace(/[^a-z0-9]/gi, '-')
    .replace(/-+/g, '-')
    .toLowerCase();
  return `pemsa-pro-${slug}.pdf`;
}
